import React from 'react';
import { Icon, NavBar } from 'antd-mobile';
import { history } from '@@/core/history';
import { goBack } from '@/utils/bridge';

interface NavProps {
  title?: string;
  right?: React.ReactNode;
  icon?: React.ReactNode;
}

const Nav: React.FC<NavProps> = (props) => {
  const { title, right = false, icon } = props;
  return (
    <NavBar
      mode="light"
      icon={icon ? icon : <Icon size={'md'} color={'#000000'} type="left" />}
      onLeftClick={() => goBack()}
      rightContent={right}
    >
      {title}
    </NavBar>
  );
};

export default Nav;
